import host from './host';
import { AppVersion } from './app';

// * 通用
export const Logo = '/static/icons/logo.png';
export const LogoWhite = '/static/icons/logo_white.png';
export const AppIcon = '/static/icons/ic_launcher.png';
export const PlusRedIcon = '/static/home/plus_red.svg';
export const PlusWhiteIcon = '/static/home/plus_white.svg';

export const QRCode = '/static/qrcode.jpg';

// 01 焦点图
export const IndexVideo = '/static/home/index-video.mp4';
export const Poster = '/static/home/poster.jpg';
export const AppImg = '/static/icons/app_img.jpg';

// 02 硬件设施服务
export const Hardware01 = '/static/home/hardware_01.jpg';
export const Hardware02 = '/static/home/hardware_02.jpg';
export const Hardware03 = '/static/home/hardware_03.jpg';
export const Hardware04 = '/static/home/hardware_04.jpg';
export const Hardware05 = '/static/home/hardware_05.jpg';
export const Hardware06 = '/static/home/hardware_06.jpg';
export const Hardware07 = '/static/home/hardware_07.jpg';

export const IconPrev = '/static/home/icon-prev.png';
export const IconNext = '/static/home/icon-next.png';

// 服务
export const NewService01 = '/static/home/new_service_01.jpg';
export const NewService02 = '/static/home/new_service_02.jpg';
export const NewService03 = '/static/home/new_service_03.jpg';
export const CompanyBg = '/static/home/company_bg.jpg';

// 03 3D内容制作服务
export const Arrow = '/static/home/arrow.png';
export const Circle = '/static/home/circle.png';

export const Content3d01 = '/static/home/3d_01.jpg';
export const Content3d02 = '/static/home/3d_02.jpg';
export const Content3d03 = '/static/home/3d_03.jpg';
export const Content3d04 = '/static/home/3d_04.jpg';

// 04 算法及软件开发服务
export const Software01 = '/static/home/software_01.png';
export const Software02 = '/static/home/software_02.png';
export const Software05 = '/static/home/software_05.jpg';
export const Software04 = '/static/home/software_04.png';

// 05 算法及软件开发服务
export const Case01 = '/static/home/case_01.jpg';
export const Case02 = '/static/home/case_02.jpg';
export const Case03 = '/static/home/case_03.jpg';
export const Case04 = '/static/home/case_04.jpg';
export const Case05 = '/static/home/case_05.jpg';
export const Case06 = '/static/home/case_06.jpg';

// 06 联系我们
export const ContactBg = '/static/home/contact_bg.jpg';
export const CompanyAddress = '/static/home/map.jpg';

//我们的服务
export const iconSer1 = '/static/home/icon-ser1.png';
export const iconSer2 = '/static/home/icon-ser2.png';
export const iconSer3 = '/static/home/icon-ser3.png';
export const iconSer4 = '/static/home/icon-ser4.png';
export const iconSer5 = '/static/home/icon-ser5.png';
export const iconSer6 = '/static/home/icon-ser6.png';

export const DetailBg = '/static/home/detail_bg.png';
export const Service01 = '/static/home/service_01.jpg';
export const Service02 = '/static/home/service_02.png';
export const Service03 = '/static/home/service_03.jpg';
export const Service04 = '/static/home/service_04.jpg';
export const Service05 = '/static/home/service_05.png';
export const Service06 = '/static/home/service_06.png';
export const Service07 = '/static/home/service_07.png';
export const Service08 = '/static/home/service_08.png';
export const Service09 = '/static/home/service_09.jpg';
export const Service10 = '/static/home/service_10.png';


export const Company01 = '/static/home/lk.jpg';
export const Company02 = '/static/home/me.jpg';
export const Company03 = '/static/home/wew.jpg';
export const Company04 = '/static/home/skq.jpg';
export const Company05 = '/static/home/bala.jpg';
export const Company06 = '/static/home/itib.jpg';
export const Company07 = '/static/home/tbe.jpg';
export const Company08 = '/static/home/gxg.jpg';
export const Company09 = '/static/home/jnby.jpg'; 
export const Company10 = '/static/home/smzp.jpg';
export const Company11 = '/static/home/htm.jpg';
export const Company12 = '/static/home/tzl.jpg'; 
export const Company13 = '/static/home/hm.jpg';
export const Company14 = '/static/home/hsb.jpg';
export const Company15 = '/static/home/yxly.jpg'; 
export const Company16 = '/static/home/zsfs.jpg';
export const Company17 = '/static/home/yjxx.jpg';
export const Company18 = '/static/home/dh.jpg'; 
export const Company19 = '/static/home/wbd.jpg'; 
export const Company20 = '/static/home/school1.jpg'; 
export const Company21 = '/static/home/school2.jpg'; 
export const Company22 = '/static/home/school3.jpg'; 
export const Company23 = '/static/home/school4.jpg'; 
export const Company24 = '/static/home/school5.jpg'; 
export const Company25 = '/static/home/zyzz.jpg'; 
export const Company26 = '/static/home/wlzy.jpg'; 
export const Company27 = '/static/home/mt.jpg'; 
export const CompanyDefault = '/static/home/company-default.png'; 